import styled from 'styled-components';

export const HorizontalLine = styled.div`
  width: 100%;
  height: 1px;
  background: #F0F1F2;
  margin-bottom: 20px;
`;

export const OpenButton = styled.button`
  border: transparent;
  background: transparent;
  color: #0047b6;
`;

export const DivComposicao = styled.div`
  display: flex;
  justify-content: space-between;
  padding-left: 10px;
  margin-bottom: 15px;

  h3 {
    color: #4A4F58;
    font-family: Public Sans;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;

export const StyledDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
  margin-right: 16px;
`;

export const OuterContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const InnerContainer = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
`;

export const CardContainer = styled.div`
  border-radius: 16px;
  background: #FFF;
  padding-top: 15px;
  margin-bottom: 15px;
`;

export const DivStatus = styled.div`
  border-radius: 0px 0px 4px 4px;
  background: ${props => props.bgcor};
  color: ${props => props.cor};
  display: flex;
  padding: 4px 10px;
  justify-content: center;
  align-items: center;
  height: 20px;
  width: 100px;
  font-weight: 600;
  font-family: Quicksand;
  font-size: 14px;
  padding: 5px 10px;
  margin-left: 950px;
  margin-top: -35px;
`;
